import { Box, Container, Flex, Image, Text } from '@grupoboticario/flora-react'
import React, { FC } from 'react'

import {
  cardsMobileAdapter,
  containerStyled,
  flexStyled,
  footerStyled,
  headerContainerStyled,
  headerStyled,
  hiddenColumns,
  mobileAdapter,
} from '@/styles/baseLayout.style'

import LogoBoticario from '../brand/LogoBoticario'
import LogoQDB from '../brand/LogoQDB'
import {
  IconAmexCard,
  IconCrueltyFree,
  IconDinersCard,
  IconEloCard,
  IconHipercardCard,
  IconMasterCard,
  IconSecurity,
  IconVisaCard,
} from '../icons'

const NextIcon = () => (
  <svg
    style={{ transform: 'rotate(180deg)' }}
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 5H3.83L7.41 1.41L6 0L0 6L6 12L7.41 10.59L3.83 7H18V5Z"
      fill="white"
    />
  </svg>
)

export const BaseLayout: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  return (
    <Flex direction="column" css={flexStyled}>
      <header style={headerStyled}>
        <Container style={headerContainerStyled}>
          <Flex align="center" justify="space-between">
            {process.env.REACT_APP_UN === 'QDB' ? (
              <LogoQDB />
            ) : (
              <LogoBoticario />
            )}
            <Box>
              <Flex gap={32}>
                <Flex gap={8} css={hiddenColumns}>
                  <IconEloCard />
                  <IconHipercardCard />
                  <IconDinersCard />
                  <IconAmexCard />
                  <IconVisaCard />
                  <IconMasterCard />
                </Flex>
                <IconSecurity />
              </Flex>
            </Box>
          </Flex>
        </Container>
      </header>
      <Container css={containerStyled}>{children}</Container>
      <footer style={footerStyled}>
        <Flex direction="column" justify="center" align="center" gap={45}>
          <Flex css={cardsMobileAdapter}>
            <IconSecurity isBlack />
            <Flex gap={8}>
              <IconEloCard />
              <IconHipercardCard />
              <IconDinersCard />
              <IconAmexCard />
              <IconVisaCard />
              <IconMasterCard />
            </Flex>
          </Flex>

          <Flex css={mobileAdapter} gap={32}>
            <Flex direction="column" align="center" gap={16}>
              <Text size="action">SUSTENTABILIDADE</Text>
              <IconCrueltyFree />
            </Flex>
            <Flex direction="column" align="center" gap={16}>
              <Text size="action">PODE CONFIAR</Text>
              <Image
                src="../../../assets/images/GrupoBoticario.png"
                alt="Logo Grupo Boticário"
              />
            </Flex>
          </Flex>

          <Flex direction="column" gap={4}>
            <Text align="center" size="auxiliarSmall">
              2021 - Interbelle Comércio de Produtos de Beleza LTDA.
            </Text>
            <Text align="center" size="auxiliarSmall">
              Rodovia Régis Bitencourt, Km 437, Ribeirão Vermelho, Registro, SP,
              CEP 11900-000 | CNPJ/MF 11.137.051/0406-41 IE 574.066.180.111
            </Text>
          </Flex>
        </Flex>
      </footer>
    </Flex>
  )
}
